import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import RadioInput from 'components/partials/radio-input/radio-input';
import { AID_STUDIO_STATUS_FORM_FIELDS } from './aid-studio.constants';

interface AidStudioFilterFormProps {
  status: string;
  onClick: (value: string | undefined) => void;
}

const AidStudioFilterForm = ({
  status,
  onClick,
}: AidStudioFilterFormProps): React.JSX.Element => {
  const { control } = useForm({
    mode: 'onChange',
  });

  return (
    <div
      className="absolute flex items-center py-1.5"
      data-testid="aid-studio-filter-status-section"
    >
      <label
        htmlFor="aid-studio-statuses"
        className="w-28 md:w-32 mr-2 md:mr-4 font-semibold text-sm md:text-base"
      >
        Filter by Status
      </label>

      <div className="flex items-center flex-wrap gap-y-2">
        <Controller
          name="status"
          control={control}
          render={({ field }) => (
            <>
              {AID_STUDIO_STATUS_FORM_FIELDS.map(
                ({ label, labelFor, valueForEdit, radioValue }) => (
                  <RadioInput
                    key={labelFor}
                    label={label}
                    labelFor={labelFor}
                    radioValue={radioValue}
                    valueForEdit={valueForEdit}
                    setAction={onClick}
                    customClass="!mb-0"
                    {...field}
                    value={status}
                    data-testid={`aid-studio-filter-status-${labelFor}`}
                  />
                )
              )}
            </>
          )}
        />
      </div>
    </div>
  );
};

export default AidStudioFilterForm;
